import { useEffect } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';

import { firestore } from '../config/firebase.config';
import useUserStore from '../stores/user.store';

const useNFTChanges = (isOn) => {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    let fishUnsubscribe, rodUnsubscribe, chestUnsubscribe;

    if (user && isOn) {
      fishUnsubscribe = onSnapshot(doc(firestore, 'user-nft-fish-changes', user.id), (snapshot) => {
        if (snapshot.exists()) {
          console.log('--- detect user fish nft changes, dispatch event to reload fish ---', snapshot.data());
          // refetch inventory
          window.dispatchGameMessageEvent?.({
            type: 'refreshInventoryFish',
            hasWaiting: false,
            notifyMessage: null,
          });
        }
      });

      rodUnsubscribe = onSnapshot(doc(firestore, 'user-nft-rod-changes', user.id), (snapshot) => {
        if (snapshot.exists()) {
          console.log('--- detect user rod nft changes, dispatch event to reload rods ---', snapshot.data());
          // refetch inventory
          window.dispatchGameMessageEvent?.({
            type: 'refreshInventoryRod',
            hasWaiting: false,
            notifyMessage: null,
          });
        }
      });

      chestUnsubscribe = onSnapshot(doc(firestore, 'user-nft-chest-changes', user.id), (snapshot) => {
        if (snapshot.exists()) {
          console.log('--- detect user chest nft changes, dispatch event to reload chests ---', snapshot.data());
          // refetch inventory
          window.dispatchGameMessageEvent?.({
            type: 'refreshInventoryChest',
            hasWaiting: false,
            notifyMessage: null,
          });
        }
      });
    }

    return () => {
      fishUnsubscribe?.();
      rodUnsubscribe?.();
      chestUnsubscribe?.();
    };
  }, [user, isOn]);
};

export default useNFTChanges;
